import { isEmpty, isNumber } from "lodash";
import { formatNumber, formatWithCommas } from "../../Utils/Toast";
import RenderOdds from "../matchDetail/RenderOdds";
import { useFavMatchOddsLogic } from "../useLogic/useFavMatchOddsLogic";

const MatchOddsFav = (props) => {
  const {
    object,
    totalMatched,
    ms,
    backOdds,
    layOdds,
    betSlipObject,
    showBetDialog,
    user,
    setShowBetDialog,
    setBetSlipObject,
    setToastObject,
    defaultStakeLimit,
    profileData,
    setLimit,
    position,
    oldBack,
    oldLay,
    active,
    handleActive,
    addToFavioute,
  } = props;
  let typeGame = "betFaire";
  const { runner, handelChange, localLimit, checkArrays } = useFavMatchOddsLogic({
    object,
    betSlipObject,
    showBetDialog,
    user,
    setShowBetDialog,
    setBetSlipObject,
    setToastObject,
    defaultStakeLimit,
    profileData,
    setLimit,
    position,
    totalMatched,
  });

  return (
    <div data-v-b7a97d9f>
      <div className="s-pb-1">
        <div className="s-relative s-py-12px s-pr-14px s-pl-7px s-text-sm s-text-primary s-bg-primary s-rounded-3px s-cursor-pointer s-transition-all s-duration-300 s-rounded-t-3px s-rounded-b-none">
          <div className="s-flex s-justify-start s-items-center s-text-market-name">
            <div
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                addToFavioute(
                  object?.eventId,
                  "Match Odds",
                  object?.marketId,
                  object?.eventType,
                  object?.market
                );
              }}
              className="s-w-16px s-h-16px s-mr-7px"
            >
              <i className="s-icon-star-solid s-text-16px s-text-market-name s-flex s-items-center" />
            </div>
            <div className="s-flex s-items-center s-flex-1">
              <span className="s-pr-2 s-text-16px s-font-bold">
                {object?.market}
              </span>
              <span className="s-pr-1 s-text-12px s-font-bold s-text-market-match-amount">
                Matched
              </span>
              <span className="s-text-12px s-font-bold s-text-market-match-amount">
                {formatNumber(totalMatched)}
              </span>
              {/* <span className="s-icon-cash-out s-text-cash-out-icon s-text-16px s-mr-7px s-ml-auto" /> */}

              <span
                onClick={() =>
                  handleActive(object?.eventId, object?.marketId, "Odds")
                }
                className={`s-icon-arrow-down-sencodary s-text-12px s-ml-auto s-text-market-name s-transition-transform s-origin-center s-duration-300 s-transform ${
                  active.includes(object?.marketId) ? "s-rotate-180" : ""
                } `}
              />
            </div>
          </div>
        </div>
        {active.includes(object?.marketId) && (
          <div className="s-pt-1px s-bg-white dark:s-bg-black-800 s-rounded-bl-lg s-rounded-br-lg">
            <div className="s-flex s-justify-between s-items-center">
              <div className="s-flex-1" />
              <div className="s-w-129px s-py-1px s-flex s-gap-1px s-text-14px s-font-bold s-leading-140">
                <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                  Back
                </div>
                <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                  Lay
                </div>
              </div>
            </div>
            <div className="s-relative">
              <div className="s-space-y-px">
                {runner?.map((item, index) => {
                  const odds_back = backOdds?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  const odds_lay = layOdds?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  const old_back = oldBack?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  const old_lay = oldLay?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  let disabelBack =
                    "lockBackBets" in item ? item?.lockBackBets : false;
                  let disabelLay =
                    "lockLayBets" in item ? item?.lockLayBets : false;
                  let disableFull = checkArrays(
                    odds_back?.slice(0, 1),
                    odds_lay?.slice(0, 1),
                    localLimit
                  );
                  let showPosition =
                    (isNumber(item?.position) &&
                      position?.length > 0 &&
                      Math.abs(item?.position) > 0) ||
                    (Math.abs(item?.newPosition) >= 0 &&
                      showBetDialog &&
                      betSlipObject?.playType == typeGame &&
                      object?.marketId == betSlipObject?.object?.newMarketId);

                  return (
                    <div className="s-flex s-justify-between s-bg-black-100 dark:s-bg-black-700">
                      <div className="s-px-2 s-flex-1 s-flex s-flex-col s-justify-center">
                        <p className="s-text-17px s-font-bold s-leading-120 s-break-words">
                          {item?.RunnerName || item?.runnerName}
                        </p>{" "}
                        {showPosition && (
                          <div
                            className="s-text-12px s-leading-150 s-flex"
                            data-testid="forecast"
                          >
                            {isNumber(item?.position) &&
                              position?.length > 0 &&
                              Math.abs(item?.position) > 0 && (
                                <span
                                  className={`s-flex s-items-center s-text-forecast-${
                                    item?.position > 0 ? "up" : "down"
                                  }-text`}
                                  data-testid="estimate-forecast"
                                >
                                  <span className="s-icon-arrow-left s-rotate-180 s-flex s-text-6px s-mx-0.5" />{" "}
                                  {isNumber(item?.position) &&
                                  Math.abs(item?.position) > 0
                                    ? item?.position > 0
                                      ? Math?.abs(item?.position).toFixed(2)
                                      : `(${Math.abs(item?.position).toFixed(
                                          2
                                        )})`
                                    : ""}
                                </span>
                              )}
                            {Math.abs(item?.newPosition) >= 0 &&
                              showBetDialog &&
                              betSlipObject?.playType == typeGame &&
                              object?.marketId ==
                                betSlipObject?.object?.newMarketId && (
                                <span
                                  className={`s-flex s-items-center s-text-forecast-${
                                    item?.newPosition > 0 ? "up" : "down"
                                  }-text`}
                                  data-testid="estimate-forecast"
                                >
                                  <span className="s-icon-arrow-left s-rotate-180 s-flex s-text-6px s-mx-0.5" />{" "}
                                  {item?.newPosition > 0
                                    ? Math.abs(item?.newPosition).toFixed(2)
                                    : `(${Math.abs(item?.newPosition).toFixed(
                                        2
                                      )})`}
                                </span>
                              )}
                          </div>
                        )}
                      </div>
                      <RenderOdds
                        component={"betFaire"}
                        index={index}
                        marketName={object?.market}
                        item={item}
                        disabelBack={disabelBack}
                        oldBack={old_back}
                        oldLay={old_lay}
                        disableFull={disableFull}
                        disabelLay={object?.market == "Win" ? true : disabelLay}
                        isInPlay={
                          ["Win", "Winner"].includes(object?.market)
                            ? true
                            : object?.status == "in_play"
                            ? true
                            : false
                        }
                        handelChange={handelChange}
                        odds_lay={odds_lay}
                        odds_back={odds_back}
                        limit={localLimit}
                        ms={ms}
                        betType={betSlipObject?.betType}
                        active={
                          showBetDialog &&
                          object?.marketId == betSlipObject?.newMarketId &&
                          item?.SelectionId ==
                            betSlipObject?.object?.SelectionId &&
                          "betFaire" == betSlipObject?.playType
                        }
                      />
                    </div>
                  );
                })}
              </div>
              {ms != 1 && (
                <div className="s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-129px s-h-full s-bg-black-600 dark:s-bg-black-800 s-opacity-80 s-text-11px s-text-white s-rounded-3px s-z-20" />
              )}
            </div>{" "}
            <div className="s-relative"></div>
            <div className="s-pt-1 s-flex s-justify-between s-items-center">
              <div className="s-px-4px s-py-5px s-flex s-gap-3px s-justify-center s-items-center s-rounded s-bg-secondary s-text-global-font-on-dark">
                <span className="s-icon-graph s-text-14px" />
                <span className="s-text-11px"> Market Depth </span>
              </div>
              <div
                className="s-flex s-gap-3px s-items-center s-text-black-600 dark:s-text-black-400"
                data-testid="betLimit"
              >
                <span className="s-icon-min-max s-text-14px" />
                <span className="s-text-12px">Min/Max</span>
                <span className="s-text-12px s-font-bold">
                  {" "}
                  {formatWithCommas(localLimit?.minAmount)}/
                  {formatWithCommas(localLimit?.maxAmount)}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MatchOddsFav;
